<template>
  <section :class="bemBlock" @click.stop="() => $refs.imageSearchInput.click()">
    <input
      ref="imageSearchInput"
      :class="[bemElement('image-search-input'), 'visually-hidden']"
      type="file"
      accept="image/png, image/jpeg"
      hidden
      @change="readBase64Image($event.target)"
    />
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { types } from '../store';
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseImageSearch',
  mixins: [bemClassesMixin],
  computed: {
    ...mapState({
      base64Image: (state) => state.search.base64Image,
    }),
  },
  watch: {
    base64Image(newState) {
      if (!newState) this.$refs.imageSearchInput.value = null;
    },
  },
  methods: {
    ...mapActions({
      readBase64Image: types.search.readBase64Image,
    }),
  },
};
</script>
